import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail, API_BASE } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr(""); setMsg("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message || "If an account exists for that email, a reset link has been sent.");
    } catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-100">
      <form onSubmit={submit} className="w-full max-w-md bg-white p-8 rounded-md border border-slate-200" data-testid="forgot-form">
        <div className="flex flex-col items-center mb-6">
          <img src={`${API_BASE}/settings/company/logo`} alt="SOS" className="h-14 w-14 rounded-md object-contain" />
          <div className="font-black text-xl mt-2">Safety Onsite Solutions</div>
        </div>
        <div className="tinylabel">Password</div>
        <h1 className="text-3xl font-black mt-1">Reset your password</h1>
        <p className="text-slate-500 mt-2 text-sm">Enter your email and we'll send you a reset link. The link expires in 1 hour.</p>
        <label className="block text-sm font-semibold text-slate-700 mt-6">Email</label>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
               data-testid="forgot-email"
               className="mt-1 w-full h-12 px-3 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" />
        {msg && <div data-testid="forgot-success" className="mt-4 text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded p-3">{msg}</div>}
        {err && <div className="mt-4 text-sm text-red-600">{err}</div>}
        <button data-testid="forgot-submit" disabled={busy}
                className="mt-6 w-full h-12 bg-green-600 hover:bg-green-700 text-white font-bold rounded-md disabled:opacity-60">
          {busy ? "Sending…" : "Send reset link"}
        </button>
        <div className="mt-4 text-sm text-center">
          <Link to="/login" className="text-green-700 font-semibold">Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}
